import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";

export const STATUS_FILTERS = [
  "All",
  "Pending",
  "In Review",
  "Approved",
] as const;

export type StatusFilter = (typeof STATUS_FILTERS)[number];

export const STATUS_FILTER_MAP: Record<Exclude<StatusFilter, "All">, string> = {
  Pending: "pending",
  "In Review": "in_review",
  Approved: "approved",
};

export function ApprovalFilterBar({
  search,
  activeFilter,
  counts,
  disabled,
  onSearchChange,
  onFilterChange,
}: {
  search: string;
  activeFilter: StatusFilter;
  counts: Record<StatusFilter, number>;
  disabled: boolean;
  onSearchChange: (value: string) => void;
  onFilterChange: (filter: StatusFilter) => void;
}) {
  return (
    <Paper
      component="section"
      aria-label="Approval queue filters"
      variant="outlined"
      sx={{ p: 2 }}
    >
      <Stack spacing={1.5}>
        <TextField
          type="search"
          size="small"
          fullWidth
          label="Search applications"
          placeholder="Search business or owner..."
          value={search}
          disabled={disabled}
          onChange={(event) => onSearchChange(event.target.value)}
        />
        <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: "wrap" }}>
          {STATUS_FILTERS.map((filter) => (
            <Button
              key={filter}
              type="button"
              size="small"
              disabled={disabled}
              variant={activeFilter === filter ? "contained" : "outlined"}
              aria-label={`${filter} ${counts[filter]}`}
              aria-pressed={activeFilter === filter}
              onClick={() => onFilterChange(filter)}
            >
              {filter} {counts[filter]}
            </Button>
          ))}
        </Stack>
      </Stack>
    </Paper>
  );
}
